"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrypt = exports.encrypt = exports.decryptString = exports.encryptString = exports.randomKeyBytes = exports.randomKey = exports.ivLength = void 0;
const base64_js_1 = require("base64-js");
const Utils_1 = require("./Utils");
// While it would be possible to let other people alter the settings,
// I feel like it'd create more confusion. All modern devices can
// handle AES-GCM-256 perfectly fine.
const settings = {
    algorithm: 'AES-GCM',
    keyLength: 256,
};
exports.ivLength = 12;
const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();
/**
 * Converts a base64-encoded key into a WebCrypto key object.
 * @param input base64-encoded string
 */
function stringToKey(input) {
    let keyBytes;
    if (typeof input === 'string') {
        keyBytes = base64_js_1.toByteArray(input);
    }
    else {
        keyBytes = new Uint8Array(input);
    }
    return crypto.subtle.importKey('raw', keyBytes, settings.algorithm, true, [
        'encrypt',
        'decrypt',
    ]);
}
/**
 * Generates a random base64 encoded key.
 */
function randomKey() {
    return __awaiter(this, void 0, void 0, function* () {
        return base64_js_1.fromByteArray(yield randomKeyBytes());
    });
}
exports.randomKey = randomKey;
/**
 * Generates a random key.
 */
function randomKeyBytes() {
    return __awaiter(this, void 0, void 0, function* () {
        const key = yield crypto.subtle.generateKey({
            name: settings.algorithm,
            length: settings.keyLength,
        }, true, ['encrypt', 'decrypt']);
        const raw = yield crypto.subtle.exportKey('raw', key);
        return new Uint8Array(raw);
    });
}
exports.randomKeyBytes = randomKeyBytes;
/**
 * Encrypts a string and returns a base64 encoded ciphertext.
 */
function encryptString(key, plaintext) {
    return __awaiter(this, void 0, void 0, function* () {
        return base64_js_1.fromByteArray(yield encrypt(key, textEncoder.encode(plaintext)));
    });
}
exports.encryptString = encryptString;
/**
 * Decrypts a string.
 */
function decryptString(key, encryptedString) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!encryptedString) {
            return null;
        }
        return textDecoder.decode(yield decrypt(key, base64_js_1.toByteArray(encryptedString)));
    });
}
exports.decryptString = decryptString;
/**
 * Encrypts a byte array.
 * @param keyStr key
 * @param data data to encrypt
 */
function encrypt(keyStr, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const key = yield stringToKey(keyStr);
        const iv = crypto.getRandomValues(new Uint8Array(12));
        const encrypted = new Uint8Array(yield crypto.subtle.encrypt({
            name: settings.algorithm,
            iv: iv,
        }, key, data));
        return Utils_1.joinArrays(iv, encrypted);
    });
}
exports.encrypt = encrypt;
/**
 * Decrypts a byte array.
 * @param keyStr key
 * @param data data to decrypt
 */
function decrypt(keyStr, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const key = yield stringToKey(keyStr);
        if (data instanceof ArrayBuffer) {
            data = new Uint8Array(data);
        }
        const [iv, realData] = Utils_1.splitArray(data, exports.ivLength);
        return new Uint8Array(yield crypto.subtle.decrypt({
            name: settings.algorithm,
            iv,
        }, key, realData));
    });
}
exports.decrypt = decrypt;
//# sourceMappingURL=AES.js.map